export const SOURCE_TYPE_SELECT = 'source-type-select'
export const CITATION_SEARCH_BAR = 'citation-search-bar'
export const CITATION_SEARCH_INPUT = 'citation-search-input'
export const CITATION_SEARCH_BUTTON = 'citation-search-button'
export const MANUAL_CITE_LINK = 'manual-cite-link'
export const WORLDCAT_LOGO = 'worldcat-logo-search'
export const SOURCE_TOOLTIP_BODY = 'source-tooltip-body'
export const TOOLTIP_TARGET_SEARCH_BOTTOM = 'tooltip-target-search-bottom'
export const TOOLTIP_TARGET_SEARCH_RESULT = 'tooltip-target-search-result'
